import {NgModule} from '@angular/core';
import {SharedModule} from '@shared/shared.module';
import {ClientFileManagerContentComponent} from './component/file-manager-content/client-file-manager-content.component';
import {GlobalFileManagerContentComponent} from './component/file-manager-content/global-file-manager-content.component';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {ClientFileManagerToolbarComponent} from './component/file-manager-toolbar/client-file-manager-toolbar.component';
import {GlobalFileManagerToolbarComponent} from './component/file-manager-toolbar/global-file-manager-toolbar.component';
import {FileManagerDynamicComponentHelper} from './file-manager-dynamic-component-helper';
import {fileManagerRoutes} from './file-manager.route';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {FileManagerService} from './services/file-manager.service';
import {FileManagerEffects} from './store/effects/file-manager.effects';
import {FileManagerReducer} from './store/reducers/file-manager.reducer';
import {AddFolderDialogComponent} from './component/dialog-components/add-folder-dialog/add-folder-dialog.component';
import {UploadFileDialogComponent} from './component/dialog-components/upload-file-dialog/upload-file-dialog.component';
import {FileNameCellViewerComponent} from './component/cell-components/file-name-cell-viewer/file-name-cell-viewer.component';
import {SharedWithMeComponent} from './component/shared-with-me/shared-with-me.component';
import {FileManagerGridComponent} from './component/file-manager-grid/file-manager-grid.component';
import {DocumentRepositoryComponent} from './component/document-repository/document-repository.component';
import {DocumentRepositoryCellViewerComponent} from './component/cell-components/document-repository-cell-viewer/document-repository-cell-viewer.component';
import {SharedDrivesComponent} from './component/shared-drives/shared-drives.component';
import {DriveComponent} from './component/drive/drive.component';
import {ParticleService} from '@core/services/particle.service';
import {DriveRowActionsCellViewerComponent} from './component/cell-components/drive-row-actions-cell-viewer/drive-row-actions-cell-viewer.component';
import {FileDialogComponent} from './component/file-dialog/file-dialog.component';
import {OrbitaxDriveComponent} from './component/drive/orbitax-drive.component';
import {OrbitaxDrivesComponent} from './component/shared-drives/orbitax-drives.component';
import {AddDriveDialogComponent} from './component/add-drive-dialog/add-drive-dialog.component';
import {CheckInDialogComponent} from './component/dialog-components/check-in-dialog/check-in-dialog.component';
import {CheckOutDialogComponent} from './component/dialog-components/check-out-dialog/check-out-dialog.component';
import {DeleteConfirmDialogComponent} from './component/dialog-components/delete-confirm-dialog/delete-confirm-dialog.component';
import {RenameDialogComponent} from './component/dialog-components/rename-dialog/rename-dialog.component';
import {VersionHistoryDialogViewComponent} from './component/dialog-components/version-history-dialog-view/version-history-dialog-view.component';
import {SharedDriveMembersCellViewerComponent} from './component/cell-components/shared-drive-members-cell-viewer/shared-drive-members-cell-viewer.component';
import {TranslationModule} from '../translation/translation.module';
import {PlatformCommand} from '@shared/commands/command-base';
import {CommandService} from '@core/services/command.service';
import {PlatformToolFileStoreHandler} from './services/platform-tool-file-store-handler';
import {CreateTeamDriveCommandHandler} from './services/create-team-drive-command-handler';
import {PlatformApiProvider} from '@shared/services/platform-api-provider';
import {FileStoreApiProvider} from './services/file-store-api-provider';
import {CreateNewFolderCommandHandler} from './services/create-new-folder-command-handler';
import {UploadFileCommandHandler} from './services/upload-file-command-handler';
import {CreateQuestionnaireCommandHandler} from './services/create-questionnaire-command-handler';
import {CreateXactScriptCommandHandler} from './services/create-xact-script-command-handler';
import {CreateVisualizationCommandHandler} from './services/create-visualization-command-handler';
import {CreateBookCommandHandler} from './services/create-book-command-handler.service';
import {CreateRichDocumentCommandHandler} from './services/create-rich-document-command-handler.service';
import {FileStoreIconViewComponent} from './component/file-store-icon-view/file-store-icon-view.component';
import {FileStoreRootViewComponent} from './component/file-store-root-view/file-store-root-view.component';
import {FileStoreTreeViewComponent} from './component/file-store-tree-view/file-store-tree-view.component';
import {FileStoreShortCutComponent} from './component/file-store-short-cut/file-store-short-cut.component';
import {IconViewComponent} from './component/icon-view/icon-view.component';
import {FileStoreExpansionPanelComponent} from '@features/file-manager/component/file-store-expansion-panel/file-store-expansion-panel.component';
import {CreateWorkbookSetCommandHandler} from '@features/file-manager/services/create-workbookset-command-handler';
import {OrbitaxFileSelectorDialogComponent} from './component/dialog-components/orbitax-file-selector-dialog/orbitax-file-selector-dialog.component';
import {FileStoreLeftPanelComponent} from './component/file-store-left-panel/file-store-left-panel.component';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {NameEllipseDirective} from './directive/name-ellipse.directive';
import {OverlayModule} from '@angular/cdk/overlay';
import {PortalModule} from '@angular/cdk/portal';
import {EmptyTrashCommandHandler} from '@features/file-manager/services/empty-trash-command-handler';
import {UseCurrentFilesCommandHandler} from '@features/file-manager/services/use-current-files-command-handler';
import {SelectFileCommandHandler} from '@features/file-manager/services/select-file-command-handler';
import {MoveItemDialogComponent} from './component/dialog-components/move-item-dialog/move-item-dialog/move-item-dialog.component';
import {AddPlatformFieldsCommandHandler} from '@features/file-manager/services/add-platform-fields-command-handler';
import {DndDirective} from './directive/dnd.directive';
import {ExportToExcelCommandHandler} from '@features/file-manager/services/export-to-excel-command-handler';
import {ShowEditsCommandHandler} from '@features/file-manager/services/show-edits-command-handler';
import {CreatePowerbiReportCommandHandler} from '@features/file-manager/services/create-powerbi-report-command-handler';
import {FillablePdfTranslationCommandComponent} from './component/fillable-pdf-translation-command/fillable-pdf-translation-command.component';
import { CreateFormDialogComponent } from './component/dialog-components/create-form-dialog/create-form-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import {PowerBiSchemaDesignerModule} from '@features/power-bi-schema-designer/power-bi-schema-designer.module';
import {AddFilesInPowerBiSchemaGraphCommandHandler} from '@features/file-manager/services/add-files-in-power-bi-schema-graph-command-handler';
import { SelectFieldsDialogComponent } from './component/select-fields-dialog/select-fields-dialog.component';
import {PlatformToolFillablePdfHandler} from '@features/file-manager/services/platform-tool-fillable-pdf-handler';
import {SavePowerBiReportCommandHandler} from '@shared/services/save-power-bi-report-command-handler';
import {CopyToWorkspaceDialogComponent} from './component/dialog-components/copy-to-workspace-dialog/copy-to-workspace-dialog.component';
import { CreateEatWorkflowDialogComponent } from './component/dialog-components/create-eat-workflow-dialog/create-eat-workflow-dialog.component';
import {CreateEatWorkflowCommandHandler} from '@features/file-manager/services/create-eat-workflow-command-handler';
import { UploadOptionsDialogComponent } from './component/dialog-components/upload-options-dialog/upload-options-dialog.component';
import { OrbitaxConnectViewComponent } from '../orbitax-connect/orbitax-connect-view/orbitax-connect-view.component';
import { ExcelFileTypeComponent } from './component/excel-file-type/excel-file-type.component';
import {CreateEliteFormSetCommandHandler} from '@features/file-manager/services/create-elite-form-set-command-handler';
import {CreateQnrSetCommandHandler} from '@features/file-manager/services/create-qnr-set-command-handler';
import {AddRemoveQnrCommandHandler} from '@features/file-manager/services/add-remove-qnr-command-handler';
import {EditFormulaExpressionComponent} from '@features/file-manager/component/edit-formula-expression/edit-formula-expression.component';
import { PlatformToolSystemWorkflowSettingsHandler } from './services/platform-tool-system-workflow-settings-handler';
import { FileSelectFromDriveDialogComponent } from './component/dialog-components/file-select-from-drive-dialog/file-select-from-drive-dialog.component';
import {PublicationHandler} from "@features/file-manager/services/publication-handler";



@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(fileManagerRoutes),
    StoreModule.forFeature('fileManager', FileManagerReducer),
    EffectsModule.forFeature([FileManagerEffects]),
    SharedModule,
    TranslationModule,
    InfiniteScrollModule,
    OverlayModule,
    PortalModule,
    MatDialogModule,
    ReactiveFormsModule.withConfig({
  callSetDisabledState: 'whenDisabledForLegacyCode',
}),
    MatFormFieldModule
  ],
  declarations: [
    GlobalFileManagerContentComponent,
    ClientFileManagerContentComponent,
    GlobalFileManagerToolbarComponent,
    ClientFileManagerToolbarComponent,
    AddFolderDialogComponent,
    UploadFileDialogComponent,
    FileNameCellViewerComponent,
    SharedWithMeComponent,
    FileManagerGridComponent,
    DocumentRepositoryComponent,
    DocumentRepositoryCellViewerComponent,
    SharedDrivesComponent,
    OrbitaxDrivesComponent,
    DriveComponent,
    OrbitaxDriveComponent,
    DriveRowActionsCellViewerComponent,
    FileDialogComponent,
    AddDriveDialogComponent,
    DeleteConfirmDialogComponent,
    CheckInDialogComponent,
    CheckOutDialogComponent,
    RenameDialogComponent,
    VersionHistoryDialogViewComponent,
    SharedDriveMembersCellViewerComponent,
    FileStoreIconViewComponent,
    FileStoreRootViewComponent,
    FileStoreTreeViewComponent,
    FileStoreShortCutComponent,
    IconViewComponent,
    FileStoreExpansionPanelComponent,
    OrbitaxFileSelectorDialogComponent,
    FileStoreLeftPanelComponent,
    NameEllipseDirective,
    MoveItemDialogComponent,
    CopyToWorkspaceDialogComponent,
    DndDirective,
    FillablePdfTranslationCommandComponent,
    CreateFormDialogComponent,
    SelectFieldsDialogComponent,
    CreateEatWorkflowDialogComponent,
    UploadOptionsDialogComponent,
    OrbitaxConnectViewComponent,
    ExcelFileTypeComponent,
    EditFormulaExpressionComponent,
    FileSelectFromDriveDialogComponent,
  ],

  exports: [
    FileDialogComponent,
    AddDriveDialogComponent,
    CheckInDialogComponent,
    CheckOutDialogComponent,
    OrbitaxFileSelectorDialogComponent,
    MoveItemDialogComponent,
    CopyToWorkspaceDialogComponent,
    FileStoreIconViewComponent,
    CreateFormDialogComponent,
    NameEllipseDirective,
    ExcelFileTypeComponent,
    EditFormulaExpressionComponent
  ],
  providers: [
    FileManagerService
  ]
})
export class FileManagerModule {
  constructor(protected particleService: ParticleService,
              protected commandService: CommandService,
              private platformApiProvider: PlatformApiProvider,
              private platformToolFileStoreHandler: PlatformToolFileStoreHandler,
              private platformToolFillablePdfHandler: PlatformToolFillablePdfHandler,
              private createTeamDriveCommandHandler: CreateTeamDriveCommandHandler,
              private createNewFolderCommandHandler: CreateNewFolderCommandHandler,
              private uploadFileCommandHandler: UploadFileCommandHandler,
              private createQuestionnaireCommandHandler: CreateQuestionnaireCommandHandler,
              private createXactScriptCommandHandler: CreateXactScriptCommandHandler,
              private createVisualizationCommandHandler: CreateVisualizationCommandHandler,
              private createBookCommandHandler: CreateBookCommandHandler,
              private createRichDocumentCommandHandler: CreateRichDocumentCommandHandler,
              private createWorkbookSetCommandHandler: CreateWorkbookSetCommandHandler,
              private emptyTrashCommandHandler: EmptyTrashCommandHandler,
              private useCurrentFilesCommandHandler: UseCurrentFilesCommandHandler,
              private selectFileCommandHandler: SelectFileCommandHandler,
              private exportToExcelCommandHandler: ExportToExcelCommandHandler,
              private addPlatformFieldsCommandHandler: AddPlatformFieldsCommandHandler,
              private showEditsCommandHandler: ShowEditsCommandHandler,
              private createPowerbiReportCommandHandler: CreatePowerbiReportCommandHandler,
              private addFilesInPowerBiSchemaGraphCommandHandler: AddFilesInPowerBiSchemaGraphCommandHandler,
              private savePowerBiReportCommandHandler: SavePowerBiReportCommandHandler,
              private createEatWorkflowCommandHandler: CreateEatWorkflowCommandHandler,
              private createEliteFormSetCommandHandler: CreateEliteFormSetCommandHandler,
              private createQnrSetCommandHandler: CreateQnrSetCommandHandler,
              private addRemoveQnrCommandHandler: AddRemoveQnrCommandHandler,
              private platformToolSystemWorkflowSettingsHandler: PlatformToolSystemWorkflowSettingsHandler,
              private publicationHandler: PublicationHandler
  ) {
    FileManagerDynamicComponentHelper.init();
    particleService.registerCellComponent('DocumentRepositoryCellViewer', DocumentRepositoryCellViewerComponent);
    particleService.registerCellComponent('DriveRowActionsCellViewer', DriveRowActionsCellViewerComponent);
    particleService.registerCellComponent('SharedDriveMembersCellViewer', SharedDriveMembersCellViewerComponent);
    FileManagerDynamicComponentHelper.register('PlatformToolFileStoreHandler', platformToolFileStoreHandler);
    FileManagerDynamicComponentHelper.register('PlatformToolFillablePdfHandler', platformToolFillablePdfHandler);
    FileManagerDynamicComponentHelper.register('CreateTeamDriveCommandHandler', createTeamDriveCommandHandler);
    FileManagerDynamicComponentHelper.register('CreateNewFolderCommandHandler', createNewFolderCommandHandler);
    FileManagerDynamicComponentHelper.register('CreateWorkbookSetCommandHandler', createWorkbookSetCommandHandler);
    FileManagerDynamicComponentHelper.register('UploadFileCommandHandler', uploadFileCommandHandler);
    FileManagerDynamicComponentHelper.register('CreateQuestionnaireCommandHandler', createQuestionnaireCommandHandler);
    FileManagerDynamicComponentHelper.register('CreateXactScriptCommandHandler', createXactScriptCommandHandler);
    FileManagerDynamicComponentHelper.register('CreateVisualizationCommandHandler', createVisualizationCommandHandler);
    FileManagerDynamicComponentHelper.register('CreateBookCommandHandler', createBookCommandHandler);
    FileManagerDynamicComponentHelper.register('CreateRichDocumentCommandHandler', createRichDocumentCommandHandler);
    FileManagerDynamicComponentHelper.register('EmptyTrashCommandHandler', emptyTrashCommandHandler);
    FileManagerDynamicComponentHelper.register('UseCurrentFilesCommandHandler', useCurrentFilesCommandHandler);
    FileManagerDynamicComponentHelper.register('SelectFileCommandHandler', selectFileCommandHandler);
    FileManagerDynamicComponentHelper.register('AddPlatformFieldsCommandHandler', addPlatformFieldsCommandHandler);
    FileManagerDynamicComponentHelper.register('ExportToExcelCommandHandler', exportToExcelCommandHandler);
    FileManagerDynamicComponentHelper.register('ShowEditsCommandHandler', showEditsCommandHandler);
    FileManagerDynamicComponentHelper.register('CreatePowerbiReportCommandHandler', createPowerbiReportCommandHandler);
    FileManagerDynamicComponentHelper.register('AddFilesInPowerBiSchemaGraphCommandHandler', addFilesInPowerBiSchemaGraphCommandHandler);
    FileManagerDynamicComponentHelper.register('SavePowerBiReportCommandHandler', savePowerBiReportCommandHandler);
    FileManagerDynamicComponentHelper.register('CreateEatWorkflowCommandHandler', createEatWorkflowCommandHandler);
    FileManagerDynamicComponentHelper.register('CreateEliteFormSetCommandHandler', createEliteFormSetCommandHandler);
    FileManagerDynamicComponentHelper.register('CreateQnrSetCommandHandler', createQnrSetCommandHandler);
    FileManagerDynamicComponentHelper.register('AddRemoveQnrCommandHandler', addRemoveQnrCommandHandler);
    FileManagerDynamicComponentHelper.register('PlatformToolSystemWorkflowSettingsHandler', platformToolSystemWorkflowSettingsHandler);
    FileManagerDynamicComponentHelper.register('PublicationHandler', publicationHandler);

    // let command = new PlatformCommand('CreateRepositoryLinkCommand', 'FileStoreApi');
    // command.fieldValues['ViewType'] = 'IconView';
    // this.commandService.registrPlatformLinkCommand('/drive', command);

    let command = new PlatformCommand('CreateDriveRootLinkCommand', 'FileStoreApi');
    this.commandService.registrPlatformLinkCommand('/drive', command);

    command = new PlatformCommand('PublicationLinkCommand', 'FileStoreApi');
    this.commandService.registrPlatformLinkCommand('/publications', command);

    command = new PlatformCommand('CreateOrbitaxRepositoryLinkCommand', 'FileStoreApi');
    this.commandService.registrPlatformLinkCommand('/orbitax-repository', command);
    this.platformApiProvider.register(new FileStoreApiProvider);

    command = new PlatformCommand('CreateOrbitaxRepositoryLinkCommand', 'FileStoreApi');
    this.commandService.registrPlatformLinkCommand('/orbitax-drives', command);
  }
}
